import NutritionFacts from './NutritionFacts'
import _NutritionalValueCalculator from './NutritionValueCalculator'

export default NutritionFacts

export const NutritionalValueCalculator = _NutritionalValueCalculator
